package io.horion.cv.models

object OrientationData {

    val domaines = listOf(
        "Informatique",
        "Finance",
        "Santé",
        "Agriculture",
//        "Marketing",
//        "Ressources humaines",
//        "Ingénierie",
//        "Commerce",
//        "Juridique",
//        "Éducation",
//        "Autre"
    )

    val postes = listOf(
        "Chef projet",
        "Data analyst",
        "CEO",
        "Magasinier",
//        "Développeur",
//        "Analyste",
//        "Directeur",
//        "Manager",
//        "Consultant",
//        "Ingénieur",
//        "Commercial",
//        "Comptable",
//        "Autre"
    )

    val experiences = listOf(
        "01", "02", "03", "04", "05"
    )
}